<template>
  <div>
    <YearMonthRange
      :targetYearMonth="targetYearMonth"
      :yearList="yearList"
      :startMonthList="startMonthList"
      :endMonthList="endMonthList"
    />
  </div>
</template>

<script>
import YearMonthRange from '@/components/Advertiser/Operation/IO/Form/FormYearMonthRange'

const START_YEAR = 2020
const END_YEAR = 2022

export default {
  name: 'CampaignModalPageAutomobileVehicleInspectionExpiration',
  components: {
    YearMonthRange,
  },
  props: {
    menuSetting: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    targetYearMonth() {
      return this.menuSetting.orderDescription.targetVehicleInspectionExpiration
    },
    yearList() {
      const years = Array.from(Array(END_YEAR - START_YEAR + 1)).map(
        (_, index) => START_YEAR + index,
      )
      return years.map(year => {
        return {
          text: year + '年',
          value: year,
        }
      })
    },
    startMonthList() {
      return this.createMonthList(this.targetYearMonth.startYear)
    },
    endMonthList() {
      return this.createMonthList(this.targetYearMonth.endYear)
    },
  },
  methods: {
    validate() {
      const startDate = new Date(
        this.targetYearMonth.startYear,
        this.targetYearMonth.startMonth,
        1,
      )
      const endDate = new Date(
        this.targetYearMonth.endYear,
        this.targetYearMonth.endMonth,
        1,
      )
      return startDate.getTime() <= endDate.getTime()
    },
    createMonthList(year) {
      const startMonth = year === START_YEAR ? 4 : 1
      const endMonth = year === END_YEAR ? 3 : 12
      const array = []
      for (let i = startMonth; i <= endMonth; i++) {
        array.push({
          text: i + '月',
          value: i,
        })
      }
      return array
    },
  },
}
</script>
